import { useTranslation } from 'react-i18next';

import { Locale, LocaleCode, selectableLocales } from './locales';
import { setLanguage } from './initialize';

type UseLanguage = {
  current: LocaleCode;
  /** Menu options — testing locales are deliberately absent. */
  locales: readonly Locale[];
  /** False while English is the only selectable locale, which hides the menu. */
  canSwitch: boolean;
  select: (code: LocaleCode) => Promise<void>;
};

export const useLanguage = (): UseLanguage => {
  const { i18n } = useTranslation();
  const locales = selectableLocales();

  return {
    current: i18n.resolvedLanguage || i18n.language,
    locales,
    canSwitch: locales.length > 1,
    select: setLanguage,
  };
};
